import styled from 'styled-components'

export const Header = styled.header`
  display: flex;
  width: fit-content;
  gap: 1rem;
`

export const Container = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`
export const Filter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1;
  flex-wrap: wrap;
  background-color: #fff;
  border: 1px solid #4949494d;
  padding: 1rem;
  border-radius: 6px;
  gap: 1rem;

  > span {
    margin-top: 1.5rem;
    text-wrap: nowrap;
    font-size: ${(props) => props.theme.font.textsm};
    color: ${(props) => props.theme.color.neutral.gray};
  }
`
export const Row = styled.div`
  display: flex;
  flex-direction: row;
  gap: 0.5rem;
`
export const InputContainer = styled.div<{ width?: string }>`
  display: flex;
  align-self: flex-end;
  gap: 0.3rem;
  flex-direction: column;
  flex: 1;
  width: ${(props) => (props.width ? props.width : '100%')};
`

export const Content = styled.div`
  display: flex;
`

export const DaterangePickerContainer = styled.div`
  display: flex;
  align-items: center;
  border: 1px solid #cecece;
  border-radius: 0.25rem;
  background-color: #f7f7f7;
  padding-right: 0.5rem;
  height: -webkit-fill-available;

  .rs-picker-toggle-wrapper {
    position: absolute;
    .rs-stack-item {
      font-size: 0.875rem;
    }
    ::placeholder {
      color: transparent;
    }

    .rs-picker-toggle-textbox {
      font-size: 0.875rem;

      ::placeholder {
        font-size: 0.875rem;
      }
    }
  }

  .rs-icon {
    display: none;
  }
`
